import { Page } from "./_page";
import { ConsumerReservations } from "../consumer_reservations";


export class ConsumerReservationsPage extends Page {

	static PAGE_CLASS = "js-consumer-reservations";

	constructor() {
		super();
		ConsumerReservations.prepareCards();
	}

}
